import styled from "styled-components";
import { colors, screenSizes, typography } from "@streeteasy/design-system";

export const BrandLinks = styled.ul`
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 12px 0 0;

  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    align-items: center;
    flex-direction: column;
  }
`;

export const BrandLink = styled.li`
  margin: 8px 0;
  @media screen and (min-width: ${screenSizes.LARGE_SCREEN + 1}px) {
    margin: "";
    &:not(:last-child)::after {
      content: "\\00B7"; // &middot;
      padding: 0 8px;
    }
  }
`;

export const BrandLinkText = styled(typography.Caps).attrs({
  as: "a",
  rel: "noreferrer noopener",
  target: "_blank"
})`
  color: ${colors.WHITE};
`;
